import { render, staticRenderFns } from "./CardTotalReceipt.vue?vue&type=template&id=61024d5f"
import script from "./CardTotalReceipt.vue?vue&type=script&lang=js"
export * from "./CardTotalReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports